var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.62 46.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#de4394;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essay_from_outline",
    "data-name": "Essay from outline"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.31,
    cy: 23.31,
    r: 23.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.418,34.188H21.734a.777.777,0,1,1,.022-1.554H23.31V30.651a8.037,8.037,0,0,1-6.993-8.118.777.777,0,0,1,.765-.787h.024a.777.777,0,0,1,.765.787,6.227,6.227,0,1,0,12.432,0v-.022a.777.777,0,0,1,1.554.022,8.037,8.037,0,0,1-6.993,8.118v1.983H26.44a.777.777,0,1,1-.012,1.554ZM20.2,23.31V16.317a3.885,3.885,0,0,1,7.77,0V23.31a3.885,3.885,0,1,1-7.77,0Zm1.554-6.993V23.31a2.331,2.331,0,0,0,4.662,0V16.317a2.331,2.331,0,1,0-4.662,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.673b7b554cb8604e2b3c14a53a5a84f7.svg";
export { ForwardRef as ReactComponent };